// Loads a portal locale's catalog (./catalogs.ts) as lazy chunks: messages/<locale>.json and the
// English one, paired by id. English pages and the public site load neither.
import { type Catalog, pairCatalogs } from "./catalogs";
import type { AppLocale } from "./config";

type CatalogModule = { default: Record<string, string> };

const CATALOG_MODULES = import.meta.glob<CatalogModule>("../../messages/*.json");
const catalogModule = (locale: string): (() => Promise<CatalogModule>) | undefined =>
  CATALOG_MODULES[`../../messages/${locale}.json`];

const loading = new Map<AppLocale, Promise<Catalog>>();

/** A locale's catalog, loaded once per page (or server isolate). */
export const loadCatalog = (locale: AppLocale): Promise<Catalog> => {
  let promise = loading.get(locale);
  if (!promise) {
    const english = catalogModule("en");
    const translated = catalogModule(locale);
    promise =
      english && translated
        ? Promise.all([english(), translated()]).then(([en, other]) =>
            pairCatalogs(en.default, other.default),
          )
        : Promise.resolve(new Map());
    loading.set(locale, promise);
  }
  return promise;
};
